<template>
  <svg 
    :height="height"
    :width="width"
    class="app-icon-imanage"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="#6763fb" d="M11.1 3c-3.8-.6-6.8 1.8-8.2 5.2-4 9.8 13.4 8.2 16.2 1.6 1.1-2.8-5.4-6.4-8-6.8"/>
    <path fill="#47b9e7" d="M8.4 15.2c-4.2 0-7.6-2.1-5.6-7 1-2.5 2.9-4.5 5.4-5.1-1-.3-2-.4-3.1-.4-.9 0-1.7.1-2.5.4-3.2 1.3-1.6 8.5.2 11 1.6 2.3 4.1 3.2 6.6 3.2 1.9 0 3.8-.5 5.5-1.3 3-1.4 3.9-3.2 3.5-5.1-2 2.6-6.3 4.2-10 4.2"/>
    <path fill="#1a40cd" d="M8.2 3.1c-2.4.6-4.3 2.6-5.4 5.1-2 4.9 1.4 7 5.6 7s8-1.6 10-4.2c-.7-3.3-5.6-6.7-10.2-7.9"/>
    <path fill="#fff" d="M12 7.4c-.6 0-1.1.2-1.5.6-.7-.8-2-.9-2.8-.1-.4.4-.6.9-.6 1.5v2.4h1V9.4c0-.5.4-.9.9-1s.9.4 1 .9v2.5h1V9.4c0-.5.4-.9.9-1 .5 0 .9.4 1 .9v2.5h1V9.4c0-1.1-.9-2-2-2M6.6 6c-.4 0-.7.3-.7.8s.3.7.8.7.7-.3.7-.7c0-.4-.3-.8-.8-.8"/>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppIconIManage',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    },
  },
})
</script>
